var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserTemplateEn = function SvgUserTemplateEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V14H2V2H14ZM15 1H1V15H15V1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 4.40039V9.00039C10.8996 9.50039 10.7996 9.90039 10.5996 10.3004C10.3996 10.7004 10.0996 11.0004 9.59961 11.2004C9.19961 11.4004 8.59961 11.5004 7.89961 11.5004C6.99961 11.5004 6.19961 11.3004 5.69961 10.8004C5.19961 10.3004 5.09961 9.80039 5.09961 9.00039V4.40039H6.59961V8.80039C6.59961 9.40039 6.69961 9.80039 6.99961 10.0004C7.19961 10.2004 7.59961 10.4004 8.09961 10.4004C8.59961 10.4004 8.99961 10.3004 9.19961 10.0004C9.39961 9.70039 9.49961 9.30039 9.49961 8.80039V4.40039H10.8996Z"
  })));
};
export default SvgUserTemplateEn;